<ng-container *ngIf="tile">
  <h4 class="title">{{ (step === steps.Settings ? 'shared.dashboards.dialog.preview' : tile.name) | translate }}</h4>
  <span class="description" *ngIf="tile.description && step !== steps.Settings">
    {{ tile.description | translate }}
  </span>
  <span class="description" *ngIf="step === steps.Settings">
    <strong>{{ 'shared.dashboards.dialog.tileType' | translate }}</strong> {{ tile.name | translate }}
  </span>
</ng-container>
